
$(document).on("click", ".slider_tabs_item", function (e) {
$('.slider_tabs_item').removeClass('active');
$(this).addClass('active');
var current_index = $(this).attr('data-slick-index');
var slider = $(this).parents('.shopify-section').find('.slick-slider');
slider.slick('slickGoTo', current_index);
});


$(document).on("click", ".custom_popup_bg,.close_popup", function(e) {
$('.custom_popup').hide();
});
$(document).on("click", 'a[href="#comparision"]', function(e) {
  e.preventDefault();
$('.custom_popup[data_tab="comparision"]').show();
});

$(document).on("click", '.ajax_add_to_cart', function(e) {
     e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
  jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
window.cart.getCart();
this_element.removeClass('loading_hk');
 } 
 });
 });